import { render, staticRenderFns } from "./LiveClip.vue?vue&type=template&id=388f4803&scoped=true"
import script from "./LiveClip.vue?vue&type=script&lang=js"
export * from "./LiveClip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f4803",
  null
  
)

export default component.exports